import React from 'react'
import './BulkSelectionBar.sass'
import Button from '../Buttons/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckDouble, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons'

const BulkSelectionBar: React.FC<{
    selectedCount: number
    entityLabel: { singular: string; plural: string }
    scopeHint?: string
    disabled?: boolean
    // Shown only while the list holds more items than the ones selected (e.g. other pages)
    selectAll?: { total: number; loading?: boolean; onClick: () => void }
    onClear: () => void
    onDelete: () => void
}> = ({ selectedCount, entityLabel, scopeHint, disabled, selectAll, onClear, onDelete }) => {
    const isSingle = selectedCount === 1

    return (
        <div className="bulk-selection-bar" role="region" aria-label="Azioni sugli elementi selezionati">
            <div className="bulk-selection-bar__info">
                <span className="bulk-selection-bar__count" aria-live="polite">
                    {selectedCount} {isSingle ? entityLabel.singular : entityLabel.plural}{' '}
                    {isSingle ? 'selezionato' : 'selezionati'}
                </span>
                {scopeHint && (
                    <span className="bulk-selection-bar__hint" title={scopeHint}>
                        {scopeHint}
                    </span>
                )}
            </div>
            <div className="bulk-selection-bar__actions">
                {selectAll && selectAll.total > selectedCount && (
                    <Button
                        buttonType="ghost"
                        customClassName="bulk-selection-bar__button"
                        loading={selectAll.loading}
                        disabled={disabled && !selectAll.loading}
                        onClick={selectAll.onClick}
                    >
                        <FontAwesomeIcon icon={faCheckDouble} />
                        Seleziona tutti ({selectAll.total})
                    </Button>
                )}
                <Button buttonType="ghost" customClassName="bulk-selection-bar__button" onClick={onClear}>
                    <FontAwesomeIcon icon={faXmark} />
                    Deseleziona
                </Button>
                <Button
                    buttonType="secondary-error"
                    customClassName="bulk-selection-bar__button bulk-selection-bar__button--delete"
                    disabled={disabled}
                    onClick={onDelete}
                >
                    <FontAwesomeIcon icon={faTrash} />
                    Elimina {selectedCount}
                </Button>
            </div>
        </div>
    )
}

export default BulkSelectionBar
